import { combineReducers } from 'redux'
import editor from './editor/index'

export default combineReducers({
  editor,
})
